import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAnalytics } from '../../services/api';
import { DashboardStats } from './dashboard/DashboardStats';
import { DashboardCharts } from './dashboard/DashboardCharts';

export const Dashboard = () => {
  const navigate = useNavigate();
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try { setAnalytics((await getAnalytics()).data); }
      catch (error) { console.error('Failed to fetch analytics:', error); }
      finally { setLoading(false); }
    };
    fetchAnalytics();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="text-white text-xl">Loading analytics...</div></div>;
  }
  if (!analytics) return null;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-green-400 mb-2">Dashboard</h1>
        <p className="text-gray-400">Analytics and insights for DharmaR</p>
      </div>
      <DashboardStats analytics={analytics} navigate={navigate} />
      <DashboardCharts analytics={analytics} navigate={navigate} />
    </div>
  );
};
